import clsx from "clsx";
import { ToolButton } from "./ToolButton";
import { t } from "../i18n";
import { useIsMobile } from "../components/App";
import { users } from "./icons";

import "./CollabButton.scss";

const CollabButton = ({
  isCollaborating,
  collaboratorCount,
  onClick,
}: {
  isCollaborating: boolean;
  collaboratorCount: number;
  onClick: () => void;
}) => {
  return (
    <>
      <ToolButton
        className={clsx("CollabButton", {
          "is-collaborating": isCollaborating,
        })}
        //onClick={onClick}
		onClick={() => {
			var i18nextLng = localStorage.getItem("i18nextLng");
			var langFlag="";
			if(i18nextLng=="zh-CN"||i18nextLng=="zh-TW"){
				langFlag="zh";
			}else if(i18nextLng=="eu-ES"){
				langFlag="es";
			}else if(i18nextLng=="ar-SA"){
				langFlag="ar";
			}else if(i18nextLng=="fr-FR"){
				langFlag="fr";
			}else if(i18nextLng=="pt-BR"){
				langFlag="pt";
			}else if(i18nextLng=="ru-RU"){
				langFlag="ru";
			}else if(i18nextLng=="ja-JP"){
				langFlag="ja";
			}else if(i18nextLng=="de-DE"){
				langFlag="de";
			}else if(i18nextLng=="it-IT"){
				langFlag="it";
			}else if(i18nextLng=="en"){
				langFlag="en";
			}
			var langUrl = '/';
			if(langFlag==null || langFlag==""){
				if(window.location.host.indexOf("iodraw")>-1){
					langFlag="zh";
				}else{
					langFlag="en";
				}
			}else{
				langUrl='/'+langFlag+'/';
				if(window.location.host.indexOf("iodraw")>-1){
					if(langFlag=="zh"){
						langUrl='/';
					}
				}else if(langFlag=="en"){
					langUrl='/';
				}
			}
			window.open(langUrl+"disk",'_blank');
		  }}
        icon={users}
        type="button"
        //title={t("labels.liveCollaboration")}
        aria-label={t("labels.liveCollaboration")}
        showAriaLabel={useIsMobile()}
      >
        {collaboratorCount > 0 && (
          <div className="CollabButton-collaborators">{collaboratorCount}</div>
        )}
      </ToolButton>
    </>
  );
};

export default CollabButton;
